
(function inicioModuleDefinition() {

    'use strict';

    angular.module('Inicio', ['ui.router', 'ui.bootstrap.carousel', 'Config', 'Entities', 'Messages'])
        .config([
            'configProvider', '$stateProvider',
            function inicioConfig(config, $stateProvider) {

                $stateProvider.state('inicio', {
                    url: "/",
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioController'
                });

                $stateProvider.state('login', {
                    url: "/login?confirmed",
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioController'
                });

                $stateProvider.state('inicio-changeuser', {
                    url: "setUser/{key}",
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioController'
                });

                $stateProvider.state('inicio-ou-lawbook-detail', {
                    url: '/Ou/{ouId}/LawBook/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioOuController',
                    authorize: true,
                    resolve: {
                        urlstate: function () {
                            return 'lawbook-detail';
                        }
                    }
                });

                $stateProvider.state('inicio-ou-certificate-detail', {
                    url: "/Ou/{ouId}/Certificate/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioOuController',
                    authorize: true,
                    resolve: {
                        urlstate: function () {
                            return 'certificate-detail';
                        }
                    }
                });

                $stateProvider.state('inicio-ou-paycheck-detail', {
                    url: "/Ou/{ouId}/Paycheck/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioOuController',
                    authorize: true,
                    resolve: {
                        urlstate: function () {
                            return 'paycheck-detail';
                        }
                    }
                });

                $stateProvider.state('inicio-ou-document-detail', {
                    url: "/Ou/{ouId}/Document/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioOuController',
                    authorize: true,
                    resolve: {
                        urlstate: function () {
                            return 'document-detail';
                        }
                    }
                });

                $stateProvider.state('inicio-ou-process-batch-detail', {
                    url: "/Ou/{ouId}/ProcessBatch/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioOuController',
                    authorize: true,
                    resolve: {
                        urlstate: function () {
                            return 'process-batch-detail';
                        }
                    }
                });
            }
        ]);
})();